export function ApplyFilterParams(url, filterData)
{
    if (!filterData)
    {
        return url;
    }

    let url_param = url;
 
    if (filterData.fromDate)
    {
        url_param += '&start=' + filterData.fromDate.unix();
    }
    else
    {
        url_param += '&start=1';
    }
    
    if (filterData.toDate)
    {
        url_param += '&end=' + filterData.toDate.unix();
    }
    else
    {
        let maxDate = new Date();
        url_param += '&end=' + Math.round(maxDate.getTime() / 1000);
    }

    if (filterData.document)
    {
        url_param += '&search=' + filterData.document;
    }

    if (filterData.minPages)
    {
        url_param += '&minPages=' + filterData.minPages;
    }

    if (filterData.maxPages)
    {
        url_param += '&maxPages=' + filterData.maxPages;
    }

    if (filterData.minCost)
    {
        url_param += '&minCost=' + filterData.minCost;
    }

    if (filterData.maxCost)
    {
        url_param += '&maxCost=' + filterData.maxCost;
    }

    if (filterData.color !== null)
    {
        url_param += '&color=' + filterData.color;
    }

    if (filterData.duplex !== null)
    {
        url_param += '&duplex=' + filterData.duplex;
    }

    return url_param;
}